import React, {Fragment, useRef} from "react";

import PropTypes from "prop-types";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {Button} from "primereact/button";
import {ToBritishDate} from "../utilities/ToMySqlDate";
import {sF} from "../utilities/NumberFormatter";

export function PrintInvoice(props) {

    const printRef = useRef(null);

    const handleDownloadPdf = async () => {
        const CONTENT_WIDTH = 200; // Your target width
        const CONTENT_HEIGHT = 145; // Your target height

        const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
        });

        // Split body items into chunks
        const ITEMS_PER_PAGE = 10;
        const tax = subtotal * sF(props.vat) / 100;
        const total = subtotal + tax;

        const pages = [];
        for (let i = 0; i < props.body.length; i += ITEMS_PER_PAGE) {
            pages.push(props.body.slice(i, i + ITEMS_PER_PAGE));
        }

        for (let i = 0; i < pages.length; i++) {
            if (i > 0) pdf.addPage("a4", "portrait");

            const tempDiv = document.createElement("div");
            // Maintain an aspect ratio similar to 200:145 for the container
            tempDiv.style.width = "1000px";
            tempDiv.style.minHeight = "725px"; // (145/200) * 1000
            tempDiv.style.padding = "40px";
            tempDiv.style.backgroundColor = "white";
            tempDiv.style.position = "absolute";
            tempDiv.style.left = "-9999px";

            const isLastPage = i === pages.length - 1;

            tempDiv.innerHTML = `
                        <div style="padding: 30px; min-height: 520px; display: flex; flex-direction: column; color: #111827; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; background-color: white;">
                            <!-- Header Section -->
                            <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 30px; border-bottom: 2px solid #e5e7eb; padding-bottom: 20px;">
                                <div>
                                    <h1 style="font-size: 24px; color: #000000; margin: 0; text-transform: uppercase; letter-spacing: 1px; font-weight: 800;">${props.name}</h1>
                                    <p style="font-size: 14px; color: #111827; margin: 4px 0 0 0; font-weight: 600;">Delivery Bill</p>
                                </div>
                                <div style="text-align: right;">
                                    <h2 style="font-size: 28px; color: #1d4ed8; margin: 0; font-weight: 700;">DELEVERY BILL</h2>
                                    <p style="font-size: 14px; margin: 5px 0 0 0; font-weight: 800; color: #000000;"># ${props.header.invoiceId}</p>
                                </div>
                            </div>

                            <!-- Info Section -->
                            <div style="display: flex; justify-content: space-between; margin-bottom: 30px;">
                                <div>
                                    <p style="font-size: 12px; text-transform: uppercase; color: #111827; margin-bottom: 5px; font-weight: 800;">Billed To</p>
                                    <p style="font-size: 16px; margin: 0; font-weight: 700; color: #000000;">${props.header.customerName}</p>
                                </div>
                                <div style="text-align: right;">
                                    <p style="font-size: 12px; text-transform: uppercase; color: #111827; margin-bottom: 5px; font-weight: 800;">Date Issued</p>
                                    <p style="font-size: 16px; margin: 0; font-weight: 700; color: #000000;">${ToBritishDate(props.header.date)}</p>
                                </div>
                            </div>

                            <!-- Table Section -->
                            <table style="width: 100%; border-collapse: collapse; flex-grow: 1;">
                                <thead>
                                    <tr style="background-color: #f3f4f6; border-bottom: 2px solid #d1d5db;">
                                        <th style="padding: 12px 10px; text-align: left; font-size: 12px; text-transform: uppercase; color: #000000; font-weight: 800;">Description</th>
                                        <th style="padding: 12px 10px; text-align: right; font-size: 12px; text-transform: uppercase; color: #000000; font-weight: 800;">Qty</th>
                                        <th style="padding: 12px 10px; text-align: right; font-size: 12px; text-transform: uppercase; color: #000000; font-weight: 800;">Price</th>
                                        <th style="padding: 12px 10px; text-align: right; font-size: 12px; text-transform: uppercase; color: #000000; font-weight: 800;">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    ${pages[i].map(item => `
                                        <tr style="border-bottom: 1px solid #e5e7eb;">
                                            <td style="padding: 12px 10px; font-size: 13px; color: #000000; font-weight: 600;">${item.name}</td>
                                            <td style="padding: 12px 10px; text-align: right; font-size: 13px; color: #000000; font-weight: 600;">${item.quantity.toLocaleString()}</td>
                                            <td style="padding: 12px 10px; text-align: right; font-size: 13px; color: #000000; font-weight: 600;">${item.price.toLocaleString()}</td>
                                            <td style="padding: 12px 10px; text-align: right; font-size: 13px; font-weight: 800; color: #000000;">${item.total.toLocaleString()}</td>
                                        </tr>
                                    `).join('')}
                                </tbody>
                            </table>
                        
                            ${isLastPage ? `
                                <div style="margin-top: 20px; align-self: flex-end; width: 280px; background-color: #f3f4f6; padding: 20px; border-radius: 8px; border: 1px solid #e5e7eb;">
                                    <div style="display: flex; justify-content: space-between; margin-bottom: 8px;">
                                        <span style="font-size: 13px; color: #000000; font-weight: 700;">Subtotal</span>
                                        <span style="font-size: 13px; font-weight: 800; color: #000000;">${subtotal.toLocaleString()}</span>
                                    </div>
                                    <div style="display: flex; justify-content: space-between; margin-bottom: 12px; padding-bottom: 12px; border-bottom: 1px solid #d1d5db;">
                                        <span style="font-size: 13px; color: #000000; font-weight: 700;">Tax (${props.vat}%)</span>
                                        <span style="font-size: 13px; font-weight: 800; color: #000000;">${tax.toLocaleString()}</span>
                                    </div>
                                    <div style="display: flex; justify-content: space-between; align-items: center;">
                                        <span style="font-size: 14px; font-weight: 900; color: #000000; text-transform: uppercase;">Total Amount</span>
                                        <span style="font-size: 20px; font-weight: 900; color: #1d4ed8;">${total.toLocaleString()}</span>
                                    </div>
                                </div>
                            ` : '<div style="flex-grow: 1;"></div>'}

                            <div style="margin-top: auto; padding-top: 20px; font-size: 10px; color: #111827; text-align: center; border-top: 1px dashed #d1d5db; font-weight: 600;">
                                Thank you for your business!
                            </div>
                        </div>
                    `;

            document.body.appendChild(tempDiv);
            const canvas = await html2canvas(tempDiv, { scale: 3 });
            const data = canvas.toDataURL("image/png");

            // Calculate X offset to center the 200mm width on A4 (210mm)
            const xOffset = (210 - CONTENT_WIDTH) / 2;
            // Position at the top (e.g., 5mm margin from the very top)
            const yOffset = 5;

            // Add image to the top half of A4
            pdf.addImage(data, "PNG", xOffset, yOffset, CONTENT_WIDTH, CONTENT_HEIGHT);

            // Page Numbering relative to the content block
            pdf.setFontSize(10);
            pdf.text(
                `Page ${i + 1} of ${pages.length}`,
                105,
                yOffset + CONTENT_HEIGHT + 5,
                { align: "center" }
            );

            document.body.removeChild(tempDiv);
        }

        const fileName = `SALE-${props.header.invoiceId}.pdf`;
        pdf.save(fileName);
    };
    const subtotal = props.body.reduce((acc, item) => acc + sF(item.total), 0);
    const tax = subtotal * sF(props.vat) / 100;
    const total = subtotal + tax;
    return (
        <>
            <div className="min-h-screen bg-gray-100 p-8 flex flex-col items-center">
                <div className="bg-white shadow-lg rounded-lg p-6 w-full max-w-2xl">
                    <div ref={printRef} className="p-4 bg-white border border-black">
                        <div className="flex justify-content-between mb-1">
                            <div>
                                <h1 className="text-3xl font-bold text-black">{props.name}</h1>
                                <p className="text-sm font-semibold text-black">DELIVERY BILL #{props.header.invoiceId}</p>
                            </div>
                            <h1 className="text-3xl font-bold text-black">DELIVERY</h1>
                        </div>
                        <div className="flex justify-content-between mb-1">
                            <div>
                                <h1 className="text-lg font-bold text-black">Customer</h1>
                                <p className="text-sm text-black">{props.header.customerName}</p>
                            </div>
                            <div>
                                <h1 className="text-lg font-bold text-black">Date :</h1>
                                <p className="text-sm text-black">{ToBritishDate(props.header.date)}</p>
                            </div>
                        </div>
                        <table className="w-full mb-8 border-collapse border border-black">
                            <thead>
                            <tr className="bg-gray-200">
                                <th className="border border-black p-2 text-left text-black">Description</th>
                                <th className="border border-black p-2 text-right text-black">Quantity</th>
                                <th className="border border-black p-2 text-right text-black">Unit Price</th>
                                <th className="border border-black p-2 text-right text-black">Total</th>
                            </tr>
                            </thead>
                            <tbody>
                            {props.body.map((item, index) => (
                                <tr key={index}>
                                    <td className="border border-black p-2 text-left text-black">{item.name}</td>
                                    <td className="border border-black p-2 text-right text-black">{item.quantity.toLocaleString()}</td>
                                    <td className="border border-black p-2 text-right text-black">{item.price.toLocaleString()}</td>
                                    <td className="border border-black p-2 text-right text-black">{item.total.toLocaleString()}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        <div className="flex justify-content-end text-black">
                            <div className="w-64">
                                <div className="flex justify-between mb-2">
                                    <span className="font-semibold">Subtotal:</span>
                                    <span>{subtotal.toLocaleString()}</span>
                                </div>
                                <div className="flex justify-between mb-2">
                                    <span className="font-semibold">Tax ({props.vat}%):</span>
                                    <span>{tax.toLocaleString()}</span>
                                </div>
                                <div className="flex justify-between font-bold text-lg border-t border-black pt-2">
                                    <span>Total:</span>
                                    <span>{total.toLocaleString()}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-6 flex justify-center">
                        <Button className="mr-2"
                                severity="warning"
                                label="Print"
                                icon="pi pi-print"
                                onClick={handleDownloadPdf}>
                        </Button>
                        <Button
                            severity="warning"
                            label="Close"
                            icon="pi pi-sign-out"
                            onClick={() => props.setPrint(false)}>
                        </Button>
                    </div>


                </div>
            </div>

        </>
    );
}
PrintInvoice.propTypes = {
    header: PropTypes.shape({
        invoiceId: PropTypes.number,
        date: PropTypes.string,
        customerName: PropTypes.string,

    }).isRequired,
    name: PropTypes.string.isRequired,
    vat: PropTypes.any.isRequired,
    body: PropTypes.array.isRequired,
    setPrint: PropTypes.func.isRequired,
    setLoading: PropTypes.func.isRequired,
}
